import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
//TODO: check usage and cleanup if not needed
export class TaasServiceDataProviderService {

  constructor() { }
}
